import React from 'react'
import Slider from '../components/core/home/SliderHome'
import NumCard from '../components/core/home/NumCard'
import CardSlider from '../components/core/home/CardSlider'
import Profile from '../components/core/home/Profile'
import ReviewPage from '../components/core/home/ReviewPage'
import Gallary from '../components/core/home/Gallary'
import Contact from '../components/core/home/Contact'

const Homepage = () => {
  return (
    <div>
       <div>
        <Slider/>
       </div>
       <div>
        <NumCard/>
       </div>
       <div>
        <Gallary/>
       </div>
       <div>
        <Profile/>
       </div>
       <div className='overflow-hidden'>
        <ReviewPage/>
       </div>
    
       
       <div>
        <CardSlider/>
       </div>
       <div>
        <Contact/>
       </div>
    </div>
  )
}

export default Homepage